import { MessageType } from "../../Constant";
import { hideLoading, resetLoading, showLoading } from "../../shared/widgets";
import { setTokenExpired } from "../actions/authActions";
import { setNotificationMessage } from "../actions/notificationAction";

export const defaultResponseFn = (response, params) => {
  const {
    dispatch,
    params: apiParams,
    action,
    customApiResponse = (res) => res,
    responseNotification = {
      status: false,
      only: false,
    },
    responseNotificationMessage = (res) => res.message,
    loaderType = "header",
    dataAccessor = {
      status: true,
      accessor(res) {
        return res.items || res.data;
      },
    },
  } = params;
  // For upload action
  if (response && response.code === 500) {
    throw response;
  }

  if (!responseNotification.only) {
    const res = customApiResponse(response, apiParams);
    // supporting the new API response format
    if (dataAccessor.status) {
      res.data = dataAccessor.accessor(response);
    }
    // action dispatch to save response to redux
    dispatch(action(res));
  }

  if (responseNotification.status) {
    // only if notification needs to be displayed.
    dispatch(
      setNotificationMessage({
        type: MessageType.SUCCESS,
        message: responseNotificationMessage(response),
      }),
    );
  }
  dispatch(hideLoading(loaderType));
};

export const defaultErrorFn = (err, params) => {
  const {
    dispatch,
    customError = (error) => error.message,
    upload = {
      status: false,
      notificationMessage: "",
      errorAction: () => {
        // errorAction
      },
      errorActionMessage: () => {
        // errorActionMessage
      },
    },
    loaderType = "header",
  } = params;
  if (err.message.includes("Invalid token")) {
    dispatch(setTokenExpired(true));
  } else if (upload.status) {
    dispatch(
      setNotificationMessage({
        type: MessageType.ERROR,
        message: upload.notificationMessage
          ? upload.notificationMessage
          : "Something went wrong",
      }),
    );
    dispatch(upload.errorAction(upload.errorActionMessage(err)));
  } else {
    const errMessage = customError(err);
    dispatch(
      setNotificationMessage({
        type: MessageType.ERROR,
        message: errMessage || "Something went wrong",
      }),
    );
  }
  dispatch(hideLoading(loaderType));
};

/**
 * creates individual action creator body
 * @param {object} params
 */
export const actionCreator = async (params) => {
  const {
    params: apiParams,
    dispatch,
    service,
    loaderType = "header",
    responseFn = defaultResponseFn,
    errorFn = defaultErrorFn,
  } = params;

  dispatch(resetLoading(loaderType));
  dispatch(showLoading(loaderType));
  try {
    const response = await service(apiParams);
    responseFn(response, params);
  } catch (err) {
    errorFn(err, params);
  }
};

/**
 * iterate over an object containing required data to create action creator.
 * @param {object} allActionCreatorData - object container data for all actions.
 * @returns an object containing all action creators.
 */

export const createAllActionCreators = (allActionCreatorData = {}) => {
  const allActionCreators = {};
  // eslint-disable-next-line no-restricted-syntax
  for (const eachActionCreator of Object.entries(allActionCreatorData)) {
    allActionCreators[
      eachActionCreator[0]
    ] = (params, loaderScope, callBack) => (dispatch) => actionCreator({
      dispatch,
      params,
      loaderType: loaderScope,
      callBack,
      ...eachActionCreator[1],
    });
  }
  return allActionCreators;
};
